export default __webpack_public_path__ + "static/media/huiyuanguanli.c4266335.png";